import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { AnyComponentData } from '../package.models';

interface QueryParams extends HttpParams {}

@Injectable({
  providedIn: 'root',
})
export class PackagesResource {
  private apiRoot: string = process.env.API_URL;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  preview(package_id: number, body: any, params?: QueryParams): Observable<AnyComponentData> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.post<AnyComponentData>(`${this.apiRoot}/${account_id}/api/packages/${package_id}/previews`, body, {
          params,
          headers: { ignoreLoadingBar: '' },
        }),
      ),
    );
  }

  previewResult(package_id: number, preview_id: number, params?: QueryParams): Observable<AnyComponentData> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<AnyComponentData>(
          `${this.apiRoot}/${account_id}/api/packages/${package_id}/previews/${preview_id}/result`,
          {
            params,
            headers: { ignoreLoadingBar: '' },
          },
        ),
      ),
    );
  }
}

((window as any).xplenty as angular.IModule).service('PackagesResource', downgradeInjectable(PackagesResource));
